import router from '../router';

function getGeneratorFromUrl() {
    return location.pathname.split('/')[1];
}

function getShareQueryName() {
    const generator = getGeneratorFromUrl();

    switch (generator) {
        case 'slang-configurator':
            return 'slang';
        case 'cilinder-configurator':
            return 'cilinder';
        case 'motor-configurator':
            return 'motor';
        default:
            return 'build';
    }
}

function getShareUrl(guid) {
    return `${window.location.host}/${getGeneratorFromUrl()}?${getShareQueryName()}=${guid}`;
}

/**
 * @param {string} name
 *
 * @returns {string|null}
 */
const getBuildUidFromUrl = () => {
    const vueRouterParam = router.currentRoute.params.uid;
    if (typeof vueRouterParam === 'string') {
        return vueRouterParam;
    }

    return new URLSearchParams(window.location.search).get(getShareQueryName());
};

export {getGeneratorFromUrl, getShareUrl, getBuildUidFromUrl};
